import { Injectable } from '@angular/core';
import {URLSearchParams} from '@angular/http';
import {ToastyService, ToastyConfig, ToastOptions} from 'ng2-toasty';

@Injectable()
export class Utils{
  constructor(
    private toastyService:ToastyService,
    private toastyConfig: ToastyConfig
  ) {
    this.toastyConfig.theme = 'default';
    this.toastyConfig.timeout = 5000;
    this.toastyConfig.showClose = true;

  }

  public buildParams(params?: any): URLSearchParams{
    let search = new URLSearchParams();

    if(typeof params !== 'undefined'){
      for (let i in params){
        if(params[i] !== undefined){
          if((i == "criado_em_to" || i == "criado_em_from")){
            let regex: any = /\d\d\/\d\d\/\d\d\d\d/;
            if(!regex.test(params[i]))
              continue;
          }
          search.set(i, params[i]);
        }
      }
    }
    return search;
  }

  public buildFormData(object: any): FormData {
    let formData:FormData = new FormData();

    for(let doc in object){
      if(typeof(object[doc]) === 'object'){
        if(object[doc] instanceof File){
          formData.append(doc,object[doc], object[doc].name );
        } else {
          this.buildFormDataRec(formData, object, doc, doc);
        }
      }else{
        formData.append(doc,object[doc]);
      }
    }

    return formData;
  }

  public ValidarCPF(strCPF: string): boolean {
    let Soma;
    let Resto;
    Soma = 0;
	  if (strCPF == "00000000000") return false;

	  for (let i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);

    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11))  Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10)) ) return false;

	  Soma = 0;

    for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);

    Resto = (Soma * 10) % 11;

    if ((Resto == 10) || (Resto == 11))  Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false;
    return true;
  }

  public flashMessage(resp, options): void{
    let toastOptions:ToastOptions = {
            title: "SCD",
            msg: resp
    };

    switch (options) {
       case 'default': this.toastyService.default(toastOptions); break;
       case 'info': this.toastyService.info(toastOptions); break;
       case 'success': this.toastyService.success(toastOptions); break;
       case 'wait': this.toastyService.wait(toastOptions); break;
       case 'danger': this.toastyService.error(toastOptions); break;
       case 'warning': this.toastyService.warning(toastOptions); break;
    }
  }

  private buildFormDataRec(formData:FormData, object:any, index:any, label:any): void{
    for(let i in object[index]){

      if(typeof(object[index][i]) === 'object'){
        let l:string = label+'['+i+']';
        if(object[index][i] instanceof File){
          formData.append(label+'['+i+']',object[index][i], object[index][i].name );
        } else {
          this.buildFormDataRec(formData, object[index], i, l);
        }
      } else {
        formData.append(label+'['+i+']',object[index][i]);
      }
    }
  }




}



// WEBPACK FOOTER //
// ./src/app/shared/utils.ts